import moment from 'moment';

import Model from 'src/storage/base';
import { userFullName, validateObj } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';

class ModifyPatientModel extends Model {
  id = 'ModifyPatientModel';
  defaultState = () => ({
    tab: 'quick',
    selectedDate: null,
    slotsMonth: [],
    slots: [],
    scheduleFlg: false,
    bulkList: Array.from({ length: 10 }, () => ({}))
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  apiConfig = {
    list: {
      url: 'schedule/list',
      validation: {
        from: 'number',
        to: 'number'
      },
      cancellable: true
    },
    invite: {
      url: 'invitation/send/patient',
      validation: {
        email: 'email',
        fullname: 'fullName',
        phoneNumber: 'phone'
      },
      cancellable: true
    },
    inviteAdvance: {
      url: 'invitation/send/patient',
      validation: {
        email: 'email',
        fullname: 'fullName',
        phoneNumber: 'phone',
        firstName: 'firstName',
        lastName: 'lastName',
        gender: 'gender',
        countryAddress: 'countryAddress',
        cityAddress: 'cityAddress',
        stateAddress: 'stateAddress',
        address: 'address',
        zipcode: 'zipcode'
      },
      cancellable: true
    },
    updatePatient: {
      url: 'patient/update',
      validation: {
        email: 'email',
        fullname: 'fullName',
        phoneNumber: 'phone',
        firstName: 'firstName',
        lastName: 'lastName',
        gender: 'gender',
        countryAddress: 'countryAddress',
        cityAddress: 'cityAddress',
        stateAddress: 'stateAddress',
        address: 'address',
        zipcode: 'zipcode'
      },
      cancellable: true
    },
    bulk: {
      url: 'invitation/bulk/patient',
      validation: {},
      cancellable: true
    },
    patient: {
      url: 'patient/detail',
      validation: {
        id: 'userId'
      },
      cancellable: true
    }
  };
  _events = {
    profile: 'handleChangeProfileAndSwitchAccount',
    location: 'initLocation'
  };

  initLocation = (data) => {
    this.cacheState = { tempCountryAddress: data.country };
    this.setState({ tempCountryAddress: data.country });
  };

  resetState = (tab) => {
    this.resetApi();
    this.setState({
      ...this.defaultState(),
      doctorId: this.state.user?.isClinic ? null : this.state.user.id,
      patient: null,
      fullname: '',
      tab: tab || 'quick',
      selectedSlot: null,
      firstName: '',
      lastName: '',
      gender: '',
      birthday: '',
      countryAddress: '',
      stateAddress: '',
      cityAddress: '',
      phoneNumber: '',
      email: '',
      address: '',
      zipcode: '',
      emails: ''
    });
  };

  loadInit = (day) => {
    this.setStateSilent({ selectedDate: day, slots: [] });
    if (!this.state.user?.isClinic) {
      this.selectedMonth(day);
    }
  };

  selectedDay = (day) => {
    this.setState({
      selectedDate: day,
      slots: this.state.slotsMonth.filter(
        (s) => s.startDate >= day.clone().startOf('day') && s.startDate <= day.clone().endOf('day')
      )
    });
  };

  selectedMonth = (day) => {
    const doctorId = model.state.doctorId;
    const start = day.clone().startOf('month').startOf('week');
    const end = day.clone().endOf('month').endOf('week');
    this.setState({ slotsMonth: [] });
    this.api(
      'list',
      {
        id: doctorId,
        from: Math.max(start.valueOf(), moment().valueOf()),
        to: end.valueOf()
      },
      (err, res, success) => {
        if (success)
          this.setState({
            slotsMonth: res.map((slot) => {
              slot.slotDate = moment(slot.startDate).format('YYYYMMDD');
              if (!slot.patientId) slot.patientId = 0;
              return slot;
            })
          });
        this.selectedDay(this.state.selectedDate);
      }
    );
  };

  sendInvite = (id, cb) => {
    let { fullname, firstName, lastName } = this.state;
    if (this.state.tab === 'advanced') fullname = userFullName(this.state);
    else {
      let splits = fullname?.split(' ');
      firstName = splits[0];
      lastName = splits[1] || ' ';
    }
    let req = {
      id,
      fullname,
      doctorId: this.state.doctorId,
      selectedSlot: this.state.scheduleFlg && this.state.selectedSlot,
      firstName,
      lastName,
      gender: this.state.gender,
      birthday: this.state.birthday || 0,
      countryAddress: this.state.countryAddress || '',
      cityAddress: this.state.cityAddress || '',
      stateAddress: this.state.stateAddress || '',
      phoneNumber: this.state.phoneNumber,
      email: this.state.email,
      address: this.state.address,
      zipcode: this.state.zipcode?.toString() || '',
      type: this.state.tab
    };

    if (req.phoneNumber && req.phoneNumber[0] === '+' && req.phoneNumber.length < 4) {
      req.phoneNumber = '';
    }
    let api = id ? 'updatePatient' : this.state.tab === 'advanced' ? 'inviteAdvance' : 'invite';
    let invalid = validateObj(req, this.apiConfig[api].validation);

    if (!req.email && !req.phoneNumber) {
      invalid.emailOrPhone = LANG_CONST.validation.email_or_phone;
      invalid.length++;
    }

    if (invalid.length) {
      return this.setInvalidApi(api, invalid);
    }

    this.api(api, req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success && !id) {
        this.resetState();
      }
    });
  };

  sendBulk = (cb) => {
    const id = 'bulk';
    this.api(id, { users: this.state.bulkList }, cb);
  };

  sendImport = (req, cb) => {
    const id = '/invitation/bulk/patient';
    this.upload(id, req, () => null, cb);
  };

  getPatient = (id, cb) => {
    this.api('patient', { id }, cb);
  };
}

const model = new ModifyPatientModel();
export default model;
